<div class="modal-container popup-general modal-sm percent_35">

    <div class="modal-container-header ">
        <span class="ml-2">{{'labels.downloadFile' | translate}}</span>
        <span class="k-icon k-i-close" (click)="closeModal(false)"></span>
    </div>
    <div class="cabecera-invoice-list content-link m-2">
        <!-- {{file}} -->
        <a href="{{dfichero}}" download>{{ 'labels.downloadFile' | translate}} <i class="fa fa-download fa-lg"
                aria-hidden="true"></i></a>

    </div>
</div>
